import { getMatchedRoutes } from "../../utils/routes.js";
import { useMatches } from "react-router";
//#region src/presentation/hooks/use-paths.tsx
var usePaths = () => {
	return getMatchedRoutes(useMatches());
};
//#endregion
export { usePaths };

//# sourceMappingURL=use-paths.js.map